var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("日均提现折线图")]),_c('div',{style:({width: '90%', height: '300px'}),attrs:{"id":"withdrawal"}})])}
var staticRenderFns = []

export { render, staticRenderFns }